/**
 *
 * @param {loan_amount: number, loan_duration: number} data
 * @returns {Promise<void>}
 */
import axios from "axios";

export const calculatePzpApi = async (data) => {
    try {
        const response = await axios.post('/api/calculate-pzp', data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

calculatePzpApi.additionalInfo = async (data) => {
    try {
        const response = await axios.post(`/api/calculate-pzp/additional-info`, data);
        return response.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
};

calculatePzpApi.vehicleOwner = async (data) => {
    try {
        const response = await axios.post(`/api/calculate-pzp/vehicle-owner`, data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

calculatePzpApi.view = async (view, data) => {
    try {
        const response = await axios.post(`/calculator-pzp/${view}`, data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

calculatePzpApi.getAddressList = async (searchText) => {
    try {
        const response = await axios.post(`/calculator-pzp/address-list`, {searchText});
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
